import { Spin } from "antd";
import React from "react";

const Spinner = () => {
	return <Spin size="large" />;
};

export default Spinner;
